import { render, staticRenderFns } from "./OrderAddProducts.vue?vue&type=template&id=3c10b47b&scoped=true&"
import script from "./OrderAddProducts.vue?vue&type=script&lang=js&"
export * from "./OrderAddProducts.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddProducts.vue?vue&type=style&index=0&id=3c10b47b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c10b47b",
  null
  
)

export default component.exports